module.exports = __webpack_public_path__ + "b5e505da3a01c0423c834d3f8e797121.png";